import { ScheduleFiltersEnum } from "features/People/types";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";

export const getScheduleFilters = (): FilterItemBase<ScheduleFiltersEnum>[] => {
  let filters: FilterItemBase<ScheduleFiltersEnum>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: ScheduleFiltersEnum.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: ScheduleFiltersEnum.DateModified,
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: ScheduleFiltersEnum.Publishers,
      placeholder: "All Publishers",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Priority",
      propertyName: ScheduleFiltersEnum.Priorities,
      placeholder: "All Priorities",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Scheduled Status",
      propertyName: ScheduleFiltersEnum.Statuses,
      placeholder: "All Statuses",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: ScheduleFiltersEnum.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: ScheduleFiltersEnum.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: ScheduleFiltersEnum.Labels,
      placeholder: "All Labels",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Objective",
      propertyName: ScheduleFiltersEnum.GoalObjectives,
      placeholder: "All Objectives",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Type",
      propertyName: ScheduleFiltersEnum.GoalTypes,
      placeholder: "All Types",
    },
  ];

  return filters;
};
